<div class="dynamic-list">
  <div class="dynamic-list__list">
    <ng-container *ngFor="let formControl of getFormControls; let i = index">
      <div class="dynamic-list__list__item">
        <ng-container
            *ngIf="itemTemplateRef"
            [ngTemplateOutlet]="itemTemplateRef"
            [ngTemplateOutletContext]="getFormContextAtIndex(i)"
        >
        </ng-container>
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="!readonly">
    <div class="dynamic-list__add-button">
      <mfp-add-button
        [iconPosition]="addButtonIconPosition"
        [iconSize]="addButtonIconSize"
        [label]="addButtonLabel"
        [color]="addButtonColor"
        (click)="addItem()"
      ></mfp-add-button>
    </div>
  </ng-container>

</div>
